export const normalizeHistoryEntry = (entry) => {
  if (!entry) return null;

  const savedAt =
    entry.savedAt ||
    entry.timestamp ||
    entry.date ||
    entry.saved_at ||
    entry.createdAt ||
    null;

  let modifications = Array.isArray(entry.modifications)
    ? entry.modifications
    : Array.isArray(entry.changes)
    ? entry.changes
    : [];

  if (
    modifications.length === 0 &&
    Array.isArray(entry.changed_fields) &&
    entry.changed_fields.includes("parametres")
  ) {
    modifications = [
      {
        field: "parametres",
        parameter: "Extracted parameters",
        oldValue: null,
        newValue: null,
        legacy: true,
      },
    ];
  }

  return {
    savedAt,
    modifications,
    totalChanges: entry.total_changes ?? modifications.length,
  };
};
